/* Mosquito Beads — variant picker styling (FINAL).
   Lives in your theme as Assets/mb-variant-picker.js,
   loaded from theme.liquid. This is the saved reference copy. */
(function () {
  var prices = null; // filled in once from /products/<handle>.js, keyed 'sig'/'side'/'mesh'
  var images = {};   // thumbnail URLs, same keys

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function resizeImg(url, size) {
    if (!url) return null;
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_' + size + 'x' + size + '_crop_center$1$2');
  }

  function loadPrices() {
    if (prices) return; // already loaded or already loading
    prices = {}; // mark as "loading" so we don't fetch twice
    fetch(window.location.pathname.replace(/\/$/, '') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        (product.variants || []).forEach(function (v) {
          var title = v.title || v.name || '';
          var key = /sidekick/i.test(title) ? 'side' : (/signature/i.test(title) ? 'sig' : (/mesh/i.test(title) ? 'mesh' : null));
          if (!key) return;
          prices[key] = v.price;
          if (v.featured_image && v.featured_image.src) images[key] = resizeImg(v.featured_image.src, 120);
        });
        decorate();
      })
      .catch(function () { /* leave prices as {} - hardcoded fallback below keeps showing */ });
  }

  function isSel(l) {
    var inp = l.querySelector('input') || l.previousElementSibling;
    if (inp && inp.tagName === 'INPUT') return inp.checked;
    if (l.getAttribute('aria-checked') === 'true' || l.getAttribute('aria-pressed') === 'true') return true;
    return /selected|active|checked/i.test(l.className);
  }
  function decorate() {
    var labels = document.querySelectorAll('fieldset label, [class*="variant"] label, .product-form label, variant-picker label');
    labels.forEach(function (l) {
      var t = (l.textContent || '').trim();
      var key = /sidekick/i.test(t) ? 'side' : (/signature/i.test(t) ? 'sig' : (/mesh/i.test(t) ? 'mesh' : null));
      if (!key) return;
      l.style.position = 'relative'; l.style.overflow = 'visible';
      l.style.setProperty('display', 'flex', 'important');
      l.style.setProperty('flex-direction', 'row', 'important');
      l.style.setProperty('align-items', 'center', 'important');
      l.style.setProperty('text-align', 'left', 'important');
      l.style.setProperty('gap', '12px', 'important');
      l.style.setProperty('padding', '16px 16px', 'important');
      l.style.setProperty('min-height', '64px', 'important');
      l.style.setProperty('border-radius', '16px', 'important');
      if (isSel(l)) {
        l.style.setProperty('background', '#d4e9f5', 'important');
        l.style.setProperty('border', '2px solid #356f93', 'important');
      } else {
        l.style.setProperty('background', '#ffffff', 'important');
        l.style.setProperty('border', '2px solid #cfe2ee', 'important');
      }
      Array.prototype.forEach.call(l.children, function (c) {
        if (c.tagName === 'INPUT') return;
        if (c.className && String(c.className).indexOf('mb-') > -1) return;
        c.style.setProperty('display', 'none', 'important');
      });
      Array.prototype.forEach.call(l.childNodes, function (n) { if (n.nodeType === 3) n.textContent = ''; });

      var fallbackPrice = key === 'sig' ? '$35.99' : (key === 'side' ? '$18.99' : '$4.99');
      var wantedPrice = (prices && prices[key] != null) ? money(prices[key]) : fallbackPrice;
      var wantedImage = images[key] || null;

      // Thumbnail, first child
      if (wantedImage) {
        var thumb = l.querySelector('.mb-thumb');
        if (!thumb) {
          thumb = document.createElement('img');
          thumb.className = 'mb-thumb';
          thumb.style.cssText = "display:block;flex:none;width:48px;height:48px;border-radius:10px;object-fit:cover;";
          l.insertBefore(thumb, l.firstChild);
        }
        if (thumb.src !== wantedImage) thumb.src = wantedImage;
      }

      // Text wrapper (name + sub), keeps them stacked next to the thumbnail
      var textwrap = l.querySelector('.mb-textwrap');
      if (!textwrap) {
        textwrap = document.createElement('span');
        textwrap.className = 'mb-textwrap';
        textwrap.style.cssText = "display:flex;flex-direction:column;flex:1;min-width:0;";
        var name = document.createElement('span'); name.className = 'mb-name';
        name.textContent = key === 'sig' ? 'The Signature' : (key === 'side' ? 'The Sidekick' : 'Clip-On Mesh Bag');
        name.style.cssText = "display:block;font-family:'scandia-web',sans-serif;font-weight:700;font-size:20px;color:#4a2e22;line-height:1.15;text-align:left;";
        var sub = document.createElement('span'); sub.className = 'mb-sub';
        sub.textContent = key === 'sig' ? '18 oz · Up to 1,000 sq ft' : (key === 'side' ? '5 oz · Up to 300 sq ft' : 'Reusable · Clip-on pouch');
        sub.style.cssText = "display:block;font-family:'scandia-web',sans-serif;font-weight:500;font-size:12px;color:#5e7c8c;margin-top:4px;line-height:1.2;text-align:left;";
        textwrap.appendChild(name); textwrap.appendChild(sub);
        l.appendChild(textwrap);
      }

      // Price, pinned right
      var price = l.querySelector('.mb-price');
      if (!price) {
        price = document.createElement('span'); price.className = 'mb-price';
        price.style.cssText = "display:block;font-family:'scandia-web',sans-serif;font-weight:700;font-size:15px;color:#4a2e22;line-height:1.2;text-align:right;flex:none;margin-left:auto;white-space:nowrap;";
        l.appendChild(price);
      }
      if (price.textContent !== wantedPrice) price.textContent = wantedPrice;

      if (key === 'sig' && !l.querySelector('.mb-bs')) {
        var b = document.createElement('span'); b.className = 'mb-bs'; b.textContent = 'Bestseller';
        b.style.cssText = "position:absolute;top:-9px;right:8px;z-index:5;background:#a64f2d;color:#fff;font-family:'scandia-web',sans-serif;font-weight:700;font-size:10px;letter-spacing:.05em;text-transform:uppercase;padding:4px 8px;border-radius:20px;pointer-events:none;";
        l.appendChild(b);
      }
    });
  }
  function init() {
    loadPrices();
    decorate();
    document.addEventListener('change', decorate, true);
    document.addEventListener('click', function () { setTimeout(decorate, 60); }, true);
    if (window.MutationObserver) { new MutationObserver(decorate).observe(document.body, { subtree: true, childList: true }); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();